var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfoSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.371 -0.000976562H18.642C23.049 -0.000976562 26 3.09302 26 7.69502V18.3173C26 22.9063 23.049 25.999 18.642 25.999H7.371C2.964 25.999 0 22.9063 0 18.3173V7.69502C0 3.09302 2.964 -0.000976562 7.371 -0.000976562ZM12.9829 8.99976C12.4457 8.99976 12 8.5529 12 8.00547C12 7.44547 12.4457 6.99976 13.0057 6.99976C13.5543 6.99976 14 7.44547 14 8.00547C14 8.5529 13.5543 8.99976 12.9829 8.99976ZM14 17.8717C14 18.4941 13.5543 18.9998 12.9943 18.9998C12.4457 18.9998 12 18.4941 12 17.8717V12.1408C12 11.5171 12.4457 10.9998 12.9943 10.9998C13.5543 10.9998 14 11.5171 14 12.1408V17.8717Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoSquare);
export default __webpack_public_path__ + "static/media/icon-Info-square.56f61e00.svg";
export { ForwardRef as ReactComponent };